/**
 * Generates a random ID consisting of alphanumeric characters and hyphens.
 * The ID has a length of 36 characters and follows a specific pattern.
 * 
 * @returns {string} The generated ID.
 */
function generateId() {
  let id = '';
  const characters = 'abcdefghijklmnopqrstuvwxyz0123456789';

  for (let i = 0; i < 36; i++) {
    if (Math.random() > 0.8 && i !== 0 && i !== 35 && id[i-1] !== '-') { // Do not add hyphen at the start or end or after a hyphen
      id += '-';
    } else {
      id += characters.charAt(Math.floor(Math.random() * characters.length));
    }
  }

  return id;
};

export const generateUUID = () => {
  let d = new Date().getTime();
  if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
    d += performance.now(); // use high-precision timer if available
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    // eslint-disable-next-line no-bitwise
    const r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    // eslint-disable-next-line no-bitwise
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
};

/**
 * Common function which used for generating a unique identifier.
 * @returns { string } A unique identifier.
 */
export const getUniqueId = (): string => {
    try {
        const uuid = generateUUID();  
        if (uuid) {
            return uuid;
        } else {
            return generateId();
        }
    } catch (err: unknown) {
        console.error(err);
    }
    return generateId();
};

export const newCorrelationId = (): string => getUniqueId();
export const newRequestId = (): string => getUniqueId();
export const newSessionId = (): string => getUniqueId();
